import { fieldVisibilityConfig } from '../config/fieldVisibilityConfig';
import { hiddenFieldsConfig } from '../config/permissions.config';

const withoutIdSuffix = (field) => (field.endsWith('Id') ? field.slice(0, -2) : field);

/**
 * Whether `role`'s deny-list (hiddenFieldsConfig) names this field — as it is, or
 * without an "Id" suffix: merchantTerminalId is the merchantTerminal reference,
 * but merchantTransactionId is a field of its own.
 */
const isHiddenForRole = (field, role) => {
    const hidden = hiddenFieldsConfig[role]?.hideFields;
    return Array.isArray(hidden) && (hidden.includes(field) || hidden.includes(withoutIdSuffix(field)));
};

export const isFieldVisibleByRole = (field, role) => {
    if (isHiddenForRole(field, role)) return false;

    const formattedField = withoutIdSuffix(field);

    const allowedRoles = fieldVisibilityConfig[formattedField];

    if (Array.isArray(allowedRoles)) {
        return allowedRoles.includes(role);
    }

    return true;
};

export const isFieldInVisibleSet = (field, visibleSet, role) => {
    const key = field.id;
    const object = field.cell === 'SelectObject' ? field.object : null;

    if (isHiddenForRole(key, role) || (field.object && isHiddenForRole(field.object, role))) {
        return false;
    }

    if (visibleSet.has(key)) return true;
    if (object && visibleSet.has(`${key}.${object}`)) return true;

    const hasConfigForField = Object.keys(fieldVisibilityConfig).some(
        (k) => k === key || k.startsWith(`${key}.`)
    );

    return !hasConfigForField;
};

export const getVisibleFieldSet = (role) => {
    const visibleFields = new Set();

    for (const key in fieldVisibilityConfig) {
        const allowedRoles = fieldVisibilityConfig[key];
        if (!allowedRoles || allowedRoles.includes(role)) {
            visibleFields.add(key);
        }
    }

    return visibleFields;
};
